export const mapProvinces = (response) => {
    return response.value;
};
export const mapProvincesFromConfig = (response) => {
    return response;
};
